import { useLocation } from "react-router-dom";

const usePublicLocation = () => {
    const location = useLocation();  
    
    const publicLocationPrefixes = [
        '/forms/public/'
    ];

    return publicLocationPrefixes.some(p => location.pathname.startsWith(p));
}

export default usePublicLocation;